/******* Angular Resourse *******/
import { Inject, Injectable } from '@angular/core';
import { BaseApi } from '@api/base/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ApiLogs extends BaseApi {

    constructor(@Inject(HttpClient) protected http: HttpClient) {
        super(http);
    }

    /**
     * GET /api-logs - get api logs
     * 
     * @param filter
     */
    public getApiLogs(filter) {
        return this.find("api-logs", filter);
    }

    /**
     * GET /api-logs/{id} - get api logs
     * 
     * @param {string} id
     */
    public getApiLogsById(id: string) {
        return this.findById("api-logs", id);
    }

    /**
     * GET /api-logs/count - get devices list count
     * 
     * @param where
     */
    public getApiLogsCount(where) {
        return this.count("api-logs", where);
    }
}